const APP_ENV = import.meta.env.VITE_APP_ENV;
const APP_URL = import.meta.env.VITE_APP_URL;

const IS_ACCOUNT_USAGE_ENABLED = import.meta.env.VITE_ACCOUNT_USAGE_ENABLED;
const IS_BILLING_PAGE_ENABLED = import.meta.env.VITE_BILLING_PAGE_ENABLED;
const IS_FREESTAR_ENABLED = import.meta.env.VITE_FREESTAR_ENABLED;
const IS_OVERHAUL_ENABLE = import.meta.env.VITE_OVERHAUL_ENABLE;
const OVERAGE_BILLING_START = import.meta.env.VITE_OVERAGE_BILLING_START;

const PADDLE_CLIENT_SECRET = import.meta.env.VITE_PADDLE_CLIENT_SECRET;
const IS_PADDLE_LIVE = import.meta.env.VITE_PADDLE_LIVE;
const PADDLE_MOCK = import.meta.env.VITE_PADDLE_MOCK === "true";

const BLACKFRIDAY_PRE_START_DATE = import.meta.env.VITE_PREBF_START;
const BLACKFRIDAY_START_DATE = import.meta.env.VITE_BF_START;
const BLACKFRIDAY_POST_START_DATE = import.meta.env.VITE_POSTBF_START;
const CYBERMONDAY_START_DATE = import.meta.env.VITE_CM_START;
const IS_BFCM_ENABLE = import.meta.env.VITE_BFCM_ENABLE;
const BFCM_COUPON = import.meta.env.VITE_BFCM_COUPON;
const BFCM_DISCOUNT = import.meta.env.VITE_BFCM_DISCOUNT;

export {
  APP_ENV,
  APP_URL,

  IS_ACCOUNT_USAGE_ENABLED,
  IS_BILLING_PAGE_ENABLED,
  IS_FREESTAR_ENABLED,
  IS_OVERHAUL_ENABLE,
  OVERAGE_BILLING_START,

  PADDLE_CLIENT_SECRET,
  IS_PADDLE_LIVE,
  PADDLE_MOCK,

  BLACKFRIDAY_PRE_START_DATE,
  BLACKFRIDAY_START_DATE,
  BLACKFRIDAY_POST_START_DATE,
  CYBERMONDAY_START_DATE,
  IS_BFCM_ENABLE,
  BFCM_DISCOUNT,
  BFCM_COUPON,
};
